
export default {
  acceptors: [],
  accreditedSuppliers: [],
  additionalFieldsTypes: [],
  additionalTenderContactPersons: [],
  agreements: [],
  applications: [],
  applicationUser: {},
  availableCards: [],
  availableOrganizations: [],
  availableOrganizationsForCurrently: [],
  biddingTypes: [],
  cartItems: [ ],
  catalog: [],
  changeOrganisation: false,
  childListOrganizators: [],
  classifications: [],
  compareItems: { tenderId: null, items: [] },
  contractNumberAndTariff: null,
  createOrdersUsers: [],
  criteria_card_templates: [],
  criterion_cards: [],
  criterion_cards_by_id: {},
  crmVerificationFillingInfo: {},
  currencies: [],
  current_user: {},
  currentOrganization: {},
  defaultTender: {
    biddingTypeId: null,
    allowRaising: false,
    biddingType: {
      biddingTypeId: null,
      titleRu: null,
      oldCode: null,
      isSale: null,
      isPublic: null,
      initialRateAvailable: null,
      bidStepAvailable: null,
      prolongationRuleAvailable: null,
      reducedPriceAvailable: null,
      analogAvailable: null,
      allowRaising: false,
      tenderingForPercentage: null,
      isMultistage: null,
      withoutPublication: null,
    },
    bidOnAllLots: false,
    bidStepType: 1,
    classificationCode: null,
    currencyOwner: 0,
    hideBestPrice: false,
    publicTenderResults: false,
    requiedAttachments: false,
    areIndividualsAllowed: null,
    tenderDescription: '',
    tenderCurrency: 'UAH',
    allowedCurrencies: null,
    tenderSubject: null,
    tenderPeriodTo: null,
    testMode: false,
    vat: false,
    isUrgent: false,
    allowParticipantBidCancellation: null,
    previousMailing: null
  },
  errors: [],
  favlists: [],
  featureDetail: [],
  features: [],
  filters: {
    'TENDERS': {
      filters: [],
      filters_mode: true,
      search: '',
      type: '',
      checkActualFilters: null
    },
    'PLANS': {
      filters: [],
      filters_mode: true,
      search: '',
      type: '',
      checkActualFilters: null
    },
    'ORDERS': {
      filters: [],
      filters_mode: true,
      search: '',
      type: '',
      checkActualFilters: null
    }
  },
  filters_templates: {
    'TENDERS': [],
    'PLANS': [],
    'ORDERS': []
  },
  holidays: [],
  measurements: [],
  mesurementUnit: [],
  topMesurementUnit: [],
  min_proposals_date: '',
  my_organizations_list: [],
  my_user: {},
  newTender: null,
  NewTenderInfo: {},
  npsUserData: null,
  personal_manager: null,
  personalManagers: [],
  prolongationRule: [],
  purchasingPlan: [],
  purchasingSettings: {},
  releases: [],
  releasesSettings: [],
  resourceGroups: [],
  resources: [],
  routerLinks: [],
  settings: {},
  growthBook: {},
  standart_criteria: [
    {
      variable: 'PRICE',
      title: 'Catalog.Price',
      type: 'NUMERIC_INPUT',
      standart: true,
    },
    {
      variable: 'QUANTITY',
      title: 'Tenders.QuantityByLot',
      type: 'NUMERIC_INPUT',
      standart: true,
    },
    {
      variable: 'UONIA',
      title: 'Tenders.NBUrate',
      type: 'NUMERIC_INPUT',
      standart: true,
    },
    {
      variable: 'REDUCEDPRICE',
      title: 'Tenders.ReducedPriceByLot',
      type: 'NUMERIC_INPUT',
      standart: true,
    },
    {
      variable: 'CURRENCYCODE',
      title: 'CURRENCYCODE',
      type: 'NUMERIC_INPUT',
      standart: true,
    }
  ],
  stateLoading: {
    status: false,
  },
  tenderStatuses: [],
  tenderAllStatuses: [],
  nbuCurrencyRate: {},
  stop_list: [],
  subcategories: [],
  subscribers: {},
  suppliersShortStatistic: {},
  supplierAddress: [],
  support: {
    email: 'info@smarttender.biz',
    fullName: 'Common.Support',
    phones: ['0 800 75 10 10', '+38 044 337 86 64', '+38 044 364 50 45'],
    skype: null,
    telegram: 'https://telegram.me/SmartTender',
    viber: 'viber://chat?number=+380992209935',
  },
  tender: {},
  tenderContactPersons: [],
  tenderProfile: {},
  tenderResources: {},
  tenders: [],
  tendersCount: 0,
  tendersCountsByTypes: {},
  tenderSettings: {},
  departments: [],
  tenderSuppliersInfo: [],
  treeView: [],
  users: [],
  warns: [],
  info: [],
  instructions: [],
  timezones: {
    uk: [],
    ru: [],
    en: [],
  },
  personalTimeZone: {
    use: false,
    organizerTimezone: 'Europe/Kiev'
  }
}
